module.exports = __webpack_public_path__ + "img/1a9da66.jpg";